// Core client
export { queryClient, type QueryInvalidateOption } from "./client";

// RFQ
export { RFQQueryOptions, useRFQ, useRFQList, invalidateRFQListQueries, invalidateRFQQueries, useCreateRFQ, useUpdateRFQ } from "./rfq";

// Awards
export { AwardsQueryOptions, invalidateRFQAwardsQueries, useRFQAwards, useDeleteAward, useUpdateAwardRationale } from "./awards";

// Rejections
export {
    RejectionsQueryOptions,
    useRFQRejections,
    useMailboxRejection,
    invalidateRFQRejectionsQueries,
    invalidateMailboxRejectionQuery,
    useCreateRejections,
    useDeleteRejection,
} from "./rejections";

// Product Catalog
export {
    CatalogQueryOptions,
    useCatalogList,
    useCatalogItem,
    useCatalogItemHistory,
    invalidateCatalogListQueries,
    invalidateCatalogItemQueries,
    invalidateCatalogItemHistoryQueries,
    useCreateCatalogItem,
    useUpdateCatalogItem,
    useDeleteCatalogItem,
    useAddCatalogItemLabel,
    useRemoveCatalogItemLabel,
    useAttachFileToCatalogItem,
    useRemoveFileFromCatalogItem,
    useAddCatalogItemsToRFQ,
    useCreateRFQFromCatalog,
} from "./catalog";

// Sourcing Requests
export {
    SourcingRequestQueryOptions,
    useSourcingRequestList,
    useSourcingRequest,
    invalidateSourcingRequestListQueries,
    invalidateSourcingRequestQueries,
    useCreateSourcingRequest,
    useUpdateSourcingRequest,
    useDeleteSourcingRequest,
    useAddItemsToSourcingRequest,
    useRemoveItemsFromSourcingRequest,
    useCreateRfqFromSourcingRequest,
    useLinkRfqToSourcingRequest,
} from "./sourcingRequests";

// Combined QueryOptions for backward compatibility
import { RFQQueryOptions } from "./rfq";
import { AwardsQueryOptions } from "./awards";
import { RejectionsQueryOptions } from "./rejections";
import { CatalogQueryOptions } from "./catalog";
import { SourcingRequestQueryOptions } from "./sourcingRequests";

export const QueryOptions = {
    ...RFQQueryOptions,
    ...AwardsQueryOptions,
    ...RejectionsQueryOptions,
    ...CatalogQueryOptions,
    ...SourcingRequestQueryOptions,
};
